import React from 'react';

export default function ProfessionalTemplate({ resumeData }) {
	const s = resumeData.sections || {};
	return (
		<div className="p-8 text-sm text-gray-900">
			{/* Header */}
			<div className="text-center border-b pb-3">
				<h1 className="text-3xl font-bold">{s.personalInfo?.name || 'Your Name'}</h1>
				<p className="text-xs mt-1">
					{s.personalInfo?.email || ''} {s.personalInfo?.phone ? '• ' + s.personalInfo?.phone : ''}{' '}
					{s.personalInfo?.location ? '• ' + s.personalInfo?.location : ''}
				</p>
			</div>
			{/* Sections */}
			<div className="mt-4 space-y-4">
				{s.personalInfo?.summary && (
					<section>
						<h2 className="font-bold uppercase tracking-wide text-xs border-b">Professional Summary</h2>
						<p className="mt-2">{s.personalInfo.summary}</p>
					</section>
				)}
				{Array.isArray(s.experience) && s.experience.length > 0 && (
					<section>
						<h2 className="font-bold uppercase tracking-wide text-xs border-b">Experience</h2>
						<div className="mt-2 space-y-2">
							{s.experience.map((e, i) => (
								<div key={i}>
									<p className="font-semibold">{e.position} • {e.company}</p>
									{e.description && <p className="text-sm">{e.description}</p>}
									{Array.isArray(e.achievements) && e.achievements.length > 0 && (
										<ul className="list-disc ml-5 text-sm">
											{e.achievements.map((a, k) => (
												<li key={k}>{a}</li>
											))}
										</ul>
									)}
								</div>
							))}
						</div>
					</section>
				)}
				{Array.isArray(s.education) && s.education.length > 0 && (
					<section>
						<h2 className="font-bold uppercase tracking-wide text-xs border-b">Education</h2>
						<div className="mt-2 space-y-2">
							{s.education.map((ed, i) => (
								<div key={i}>
									<p className="font-semibold">{ed.degree} • {ed.institution}</p>
									{ed.field && <p className="text-sm">{ed.field}</p>}
								</div>
							))}
						</div>
					</section>
				)}
				{Array.isArray(s.skills) && s.skills.length > 0 && (
					<section>
						<h2 className="font-bold uppercase tracking-wide text-xs border-b">Skills</h2>
						<ul className="mt-2 space-y-1">
							{s.skills.map((cat, i) => (
								<li key={i}>
									<span className="font-medium">{cat.category}:</span> {(cat.items || []).join(', ')}
								</li>
							))}
						</ul>
					</section>
				)}
			</div>
		</div>
	);
}


